import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import CircularProgress from '@mui/material/CircularProgress';
import { ExceptionsDialogActions } from '../../Actions/ExceptionsDialogActions';

export const ExceptionsDialogLoading: React.FC = () => (
  <>
    <DialogContent>
      <CircularProgress aria-label="Loading data" />
    </DialogContent>
    <ExceptionsDialogActions allDisabled />
  </>
);
